import { render, staticRenderFns } from "./WGSearch.vue?vue&type=template&id=3c1c35fc&scoped=true&"
import script from "./WGSearch.vue?vue&type=script&lang=js&"
export * from "./WGSearch.vue?vue&type=script&lang=js&"
import style0 from "./WGSearch.vue?vue&type=style&index=0&id=3c1c35fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c35fc",
  null
  
)

export default component.exports